import { useEffect, useState } from 'react';

/**
 * Valore ritardato di `delay` ms. Sorgente unica.
 *
 * Esistevano QUATTRO copie identiche (ClientiPage, CreaRichiestaPage,
 * CambiaClienteModal, CambiaProduttoreModal), tutte con lo stesso corpo: il
 * debito era censito in CLAUDE.md con la regola «estrai quando ne aggiungi un
 * altro», e l'autocomplete cliente delle uscite era il quinto.
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState<T>(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
}

export default useDebounce;
